exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Questrial);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@200&display=swap);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@200;800&display=swap);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@200;600;800&display=swap);", ""]);
// Module
exports.push([module.id, "#app {\n  font-family: \"Open Sans\", Helvetica, Arial, Verdana, sans-serif;\n}", ""]);
